import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/ClaimSuccess.css';

export default function ClaimSuccessPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [chainData, setChainData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Claim the chain
    claimChain();
  }, [code]);

  const claimChain = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      
      if (!token) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`/api/chains/claim/${code}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to claim chain');
      }

      setChainData(result.data);

      // Trigger confetti animation on success
      if (window.confetti) {
        window.confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 }
        });
      }
    } catch (err) {
      console.error('Error claiming chain:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShare = (platform) => {
    if (!chainData) return;

    const shareText = `Join my prayer chain! ${chainData.shareUrl}`;

    switch (platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'copy':
        navigator.clipboard.writeText(chainData.shareUrl);
        alert('Link copied to clipboard!');
        break;
      default:
        break;
    }
  };

  if (isLoading) {
    return (
      <div className="claim-success-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Activating your prayer chain...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="claim-success-container">
        <div className="claim-success-card">
          <div className="error-icon">❌</div>
          <h1>Something went wrong</h1>
          <p className="error-message">{error}</p>
          <button 
            onClick={() => navigate('/create-chain')}
            className="primary-button"
          >
            Create New Chain
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="claim-success-container">
      <div className="claim-success-card">
        <div className="success-icon">✨</div>
        <h1>Your Prayer Chain is Live!</h1>
        <p className="success-message">
          Your prayer chain is now active and ready to be shared.
        </p>

        <div className="share-section">
          <h2>Share Your Chain</h2>
          <p>Invite others to join and complete prayers together</p>

          <div className="share-buttons">
            <button 
              onClick={() => handleShare('whatsapp')}
              className="share-button whatsapp"
            >
              <span>📱</span>
              WhatsApp
            </button>

            <button 
              onClick={() => handleShare('copy')}
              className="share-button copy"
            >
              <span>🔗</span>
              Copy Link
            </button>
          </div>

          <div className="share-link-display">
            <code>{chainData?.shareUrl}</code>
          </div>
        </div>

        <div className="action-buttons">
          <button 
            onClick={() => navigate(`/pg/${code}`)}
            className="primary-button"
          >
            View Chain Dashboard
          </button>

          <button 
            onClick={() => navigate('/create-chain')}
            className="secondary-button"
          >
            Create Another Chain
          </button>
        </div>
      </div>
    </div>
  );
}
